import React from 'react';
import Paper from '@mui/material/Paper';
import { makeStyles } from 'tss-react/mui';

import SadInboxIcon from 'ha/custom-icons/sad-inbox.svg';
import { Col, Row, Text, units } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { SearchAlert } from './SearchAlerts/SearchAlert';

const useStyles = makeStyles()(() => ({
  wrapper: {
    margin: units.rem(1.5),
    flexGrow: 2,
  },
  root: {
    padding: units.rem(1),
  },
  sadIcon: {
    marginTop: units.rem(1),
    fontSize: units.rem(5),
  },
}));

const SearchResultsEmpty: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <div className={classes.wrapper}>
      <Row spacing={4}>
        <Col xs={12}>
          <Paper
            classes={{
              root: classes.root,
            }}
          >
            <Row spacing={3}>
              <Col>
                <Text variant="h6" fw="bold">
                  {T('search_empty_title')}
                </Text>
              </Col>
            </Row>
            <Row spacing={3}>
              <Col>{T('search_empty_text_search_alert')}</Col>
            </Row>
            <Row spacing={3}>
              <Col>
                <SearchAlert />
              </Col>
            </Row>
          </Paper>
        </Col>
      </Row>
      <Row alignItems="center" justifyContent="center" spacing={4}>
        <Col>
          <SadInboxIcon className={classes.sadIcon} />
        </Col>
      </Row>
    </div>
  );
};

export { SearchResultsEmpty };
